import { React, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  companyProfile,
  updateCompanySettings,
  companyDeliveryAddresses,
  deleteCompany,
  fetchUserData,
  setUser,
} from "../../redux/actions";
import { toast } from "react-toastify";
//import { CompanyAddressModal } from "../../components/modals/CompanyAddressModal";
import CompanyActions from "../self_service/CompanyActions";

const Company = () => {
  const user_company = useSelector((state) => state?.user_data?.user_data);

  const local_user_orders = user_company?.company?.local_user_order_submits;
  const lpo_setting = user_company?.company?.lpo_setting;

  const [formData, setFormData] = useState({
    lpo_setting: lpo_setting,
    local_user_orders: local_user_orders,
  });

  const selectedRegion = useSelector((state) => state?.region?.region);
  const code = user_company?.company?.currency?.value || null;

  const options = [
    { value: "QAR", label: "Qatar" },
    { value: "AED", label: "United Arab Emirates" },
    { value: "OMR", label: "Oman" },
    { value: "SAR", label: "Kingdom of Saudi Arabia" },
  ];

  const selectedOption = options.find((option) => option.value === code);
  //const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [pageData, setPageData] = useState(null);
  const [addressData, setAddressData] = useState([]);
  const [specialPriceCount, setSpecialPriceCount] = useState(null);
  const [totalDispensers, setTotalDispensers] = useState(null);
  const [credit, setCredit] = useState(null);
  const [creditPeriod, setcreditPeriod] = useState(null);
  const [region_contact_persons, setRegioncontactpersons] = useState([]);
  const [dispensers, setDispensers] = useState([]);

  const [activeTab, setActiveTab] = useState("");
  const [isOpen, setIsOpen] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await companyProfile();
        if (result?.page?.data) {
          setPageData(result.page);
        } else {
          setError("User data not found");
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
        setError("Error fetching page data");
      } finally {
        //setLoading(false);
      }
    };

    const fetchCompanyAddress = async () => {
      try {
        const result = await companyDeliveryAddresses();
        if (result?.page?.data) {
          //console.log("addresss1", result?.page?.data);
          setAddressData(result?.page?.data);
        } else {
          setError("User data not found");
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
        setError("Error fetching page data");
      } finally {
        //setLoading(false);
      }
    };

    fetchData();
    fetchCompanyAddress();
  }, []);

  useEffect(() => {
    if (pageData) {
      setDispensers(pageData.data?.location_loaned_products);
      const totalDispensers = dispensers.reduce(
        (acc, add) => (add?.loaned_product_count || 0) + acc,
        0
      );
      setTotalDispensers(totalDispensers);
      const specialPriceCount = pageData.data?.special_prices_count || 0;
      setSpecialPriceCount(specialPriceCount);
      const credits =
        Number(user_company?.company?.credit_limit) -
        Number(user_company?.company?.credit_used);
      setCredit(credits);
      const creditPeriods = user_company?.company?.credit_period?.Days;
      setcreditPeriod(creditPeriods);

      //Get Contact Persons
      //const PREVIEW_COUNT = 4;
      const contact_persons = pageData.data?.contact_persons_list || [];
      const region_contact_persons = [];

      contact_persons.map((value, key) => {
        var companies = value?.companies || [];
        var company_id = user_company?.company?.id;

        if (value.region === selectedRegion) {
          if (companies.indexOf(company_id) > -1) {
            region_contact_persons.push(value);
          }
        }
      });

      setRegioncontactpersons(region_contact_persons);
    }
  }, [pageData,dispensers, selectedRegion, user_company]);

  const handleOrderChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value === "true",
    }));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await updateCompanySettings(formData);

      if (response) {
        const result_data = await companyDeliveryAddresses();
        if (result_data?.page?.data) {
          //console.log("addresss2", result_data?.page?.data);
          setAddressData(result_data?.page?.data);
        }
        toast.success("Company Settings updated successfully!");
      } else {
        setError("Data not found");
      }
    } catch (error) {
      toast.error("Error updating profile:", error.message);
    }
  };

  const filterAvailable = ({ loaned_product_count = 0 }) =>
    Boolean(loaned_product_count);
  let locations_data =
    addressData?.location_loaned_products?.filter(filterAvailable) || [];

  const billingAddress = user_company?.company?.billing_address || "";

  const handleDelete = async (location_id, event) => {
    event.preventDefault(); // Prevent page reload
    try {
      const formData = { location_id: location_id };
      const result = await deleteCompany(formData);
      // console.log("del_comp", result);
      if (result) {
        const result_data = await companyDeliveryAddresses();
        const user_updated_data = await fetchUserData();
        if (user_updated_data) {
          dispatch(setUser(user_updated_data));
        }
        if (result_data?.page?.data) {
          // console.log("addresss3", result?.page?.data);
          setAddressData(result_data?.page?.data);
        }
        toast.success("Address Deleted Successfully!");
      } else {
        setError("Data not found");
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
      setError("Error fetching page data");
      toast.error("Error fetching page data!");
    }
  };

  const locations = addressData.delivery_locations || [];

  const handleEdit = (id) => {
    navigate(`/self-service/mycompany/actions/${id}`);
  };

  return (
    <section className="hot-deals pt-20">
      {/* component 1 about us*/}

      <form onSubmit={handleSubmit}>
        <div className="container container-lg">
          <div className="section-heading">
            <div className="flex-between flex-wrap gap-8">
              <h5 className="mb-0 text-blue">
                MY <b>COMPANY PROFILE</b>
              </h5>
              {activeTab === "Settings" && (
                <button className="btn btn-primary" type="submit">
                  Save Changes
                </button>
              )}
            </div>
          </div>
        </div>

        <div className="container container-lg ">
          <ul
            className="nav common-tab nav-pills"
            id="pills-tab"
            role="tablist"
          >
            <li className="nav-item" role="presentation">
              <button
                className="nav-link active"
                id="pills-all-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-all"
                type="button"
                role="tab"
                aria-controls="pills-all"
                aria-selected="true"
                onClick={() => setActiveTab("General")}
              >
                General
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className="nav-link"
                id="pills-grocery-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-grocery"
                type="button"
                role="tab"
                aria-controls="pills-grocery"
                aria-selected="false"
                onClick={() => setActiveTab("Addresses")}
              >
                Addresses
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className="nav-link"
                id="pills-fruits-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-fruits"
                type="button"
                role="tab"
                aria-controls="pills-fruits"
                aria-selected="false"
                onClick={() => setActiveTab("Settings")}
              >
                Settings
              </button>
            </li>
          </ul>
          <div className="tab-content" id="pills-tabContent">
            <div
              className="tab-pane fade show active"
              id="pills-all"
              role="tabpanel"
              aria-labelledby="pills-all-tab"
              tabIndex={0}
            >
              <div className="container container-lg ">
                <div className="row gy-4">
                  {/* grid for orders */}
                  <div className="col-sm-6 ">
                    <div className="position-relative transition-2 offer-card position-relative overflow-hidden p-16">
                      <div className="py-xl-4">
                        <h4 className="text-blue mb-8">Company Data</h4>
                      </div>
                      <div className="w-100 p-2">
                        {/* Company Name */}
                        <div className="d-flex flex-column flex-md-row">
                          <p className="text-black m-0 col-md-5">
                            Company Name
                          </p>
                          <p className="text-black m-0 text-start col-md-7">
                            {user_company?.company?.name || ""}
                          </p>
                        </div>
                        <hr />

                        {/* Registration Country */}
                        <div className="d-flex flex-column flex-md-row">
                          <p className="text-black m-0 col-md-5">
                            Registration Country
                          </p>
                          <p className="text-black m-0 text-start col-md-7">
                            {selectedOption?.label || ""}
                          </p>
                        </div>
                        <hr />

                        {/* Registration Number */}
                        <div className="d-flex flex-column flex-md-row">
                          <p className="text-black m-0 col-md-5">
                            Registration Number
                          </p>
                          <p className="text-black m-0 text-start col-md-7">
                            {user_company?.company?.code || ""}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* <div className="col-sm-6 ">
                  <div className="position-relative transition-2 offer-card position-relative overflow-hidden p-16">
                    <div className="py-xl-4">
                      <h4 className="text-blue ack mb-8">Contact person</h4>

                      <div className="center col-xxl-3 col-lg-12 col-sm-6">
                        <button
                          className="le btn btn-main d-inline-flex align-items-center gap-8 mt-24"
                          type="button"
                        ></button>
                      </div>
                    </div>
                  </div>
                </div> */}
                  <div className="col-sm-6  ">
                    <div className="border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2 offer-card position-relative overflow-hidden p-16 bg-color-one">
                      <div className="py-xl-4 ">
                        <h4 className="text-blue mb-8">Contact Person</h4>
                        <ul className="list-inside mt-32 ms-16">
                          {region_contact_persons?.length === 0 && (
                            <li className="text-gray-400 mb-4">
                              No contact persons configured
                            </li>
                          )}
                          {region_contact_persons &&
                            region_contact_persons.map((item, key) => (
                              <div
                                className="d-flex flex-wrap w-100 p-2 align-items-start"
                                key={key}
                              >
                                <span className="text-sm w-50">
                                  <p className="text-black m-0">
                                    {item.image && (
                                      <img
                                        style={{
                                          height: "150px",
                                          width: "150px",
                                        }}
                                        src={item.image?.files?.original?.url}
                                        alt=""
                                      />
                                    )}
                                  </p>
                                </span>
                                <span className="w-50">
                                  <ul>
                                    {item.name && (
                                      <li>
                                        <h4>{item.name}</h4>
                                      </li>
                                    )}
                                    {item.designation && (
                                      <li> {item.designation}</li>
                                    )}
                                    {item.phone && <li> {item.phone}</li>}
                                    {item.email && <li> {item.email}</li>}
                                  </ul>
                                </span>
                              </div>
                            ))}
                        </ul>
                      </div>
                    </div>
                    <br></br>
                    <div className="border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2 offer-card position-relative overflow-hidden p-16">
                      <div className="py-xl-4">
                        <h4 className="text-blue mb-8">My agreements</h4>
                        <p className="text-black mb-8"></p>
                        {specialPriceCount === 0 &&
                          totalDispensers === 0 &&
                          credit === null && (
                            <p>
                              Your company does not have agreements from Dhofar
                              Global.
                            </p>
                          )}
                        {Boolean(specialPriceCount) && (
                          // <li>
                          //   <ul className="list-inside mt-32 ms-16">
                          <li className="text-gray-400 mb-4">
                            Special prices for {specialPriceCount} products
                          </li>
                          //   </ul>
                          // </li>
                        )}
                        {Boolean(totalDispensers) && (
                          <li>
                            Total of {totalDispensers} dispensers in &nbsp;
                            {dispensers.length} locations
                          </li>
                        )}
                        {credit !== null && creditPeriod !== null && (
                          <li>
                            Credit limit {credit}, credit period {creditPeriod}
                            &nbsp; days
                          </li>
                        )}
                        {credit !== null &&
                          creditPeriod === null &&
                          creditPeriod !== "undefined" && (
                            <li>
                              Credit limit {credit}, credit period is unknown
                            </li>
                          )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="tab-pane fade"
              id="pills-grocery"
              role="tabpanel"
              aria-labelledby="pills-grocery-tab"
              tabIndex={0}
            >
              {/* component 1 about us*/}
              <div className="container container-lg ">
                <div className="row gy-4">
                  {/* grid for orders */}
                  <div className="col-sm-6 ">
                    <div className="border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2 offer-card position-relative overflow-hidden p-16">
                      <div className="py-xl-4">
                        <h3 className="text-blue ack mb-8">
                          Billing address (legal)
                        </h3>
                        <hr></hr>
                        <div>
                          <div className="d-flex flex-wrap w-100 p-2 align-items-start">
                            <span className="text-sm text-white w-50 w-sm-100 text-start d-inline-block">
                              <p className="text-black m-0">
                                Registration country
                              </p>
                            </span>
                            <span className="text-sm text-main-two-600 w-50 w-sm-100 text-start d-flex align-items-start">
                              <p className="text-black m-0">
                                {selectedOption.label}
                              </p>
                            </span>
                          </div>
                          <hr />
                          <div className="d-flex flex-wrap w-100 p-2 align-items-start">
                            <span className="text-sm text-white w-50 w-sm-100 text-start d-inline-block">
                              <p className="text-black m-0">Address</p>
                            </span>
                            <span className="text-sm text-main-two-600 w-50 w-sm-100 text-start d-flex align-items-start">
                              <p className="text-black m-0">
                                {" "}
                                {[
                                  billingAddress.address_line_1,
                                  billingAddress.address_line_2,
                                  billingAddress.address_line_3,
                                  billingAddress.postal_code,
                                  billingAddress.street,
                                  billingAddress.city,
                                ]
                                  .filter(Boolean) // Removes empty or undefined values
                                  .join(", ")}
                              </p>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* grid for savings */}
                  <div className="col-sm-6 ">
                    <div className="border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2 offer-card position-relative overflow-hidden p-16">
                      <div className="py-xl-4">
                        <h3 className="text-blue mb-8">Delivery address</h3>
                        <hr></hr>
                        {locations.length === 0 ? (
                          <div className="d-flex flex-wrap w-100 p-2 align-items-start">
                            <span className="text-sm text-white w-50 w-sm-100 text-start">
                              <p className="text-black m-0">
                                Your company does not have any locations yet.
                              </p>
                            </span>
                          </div>
                        ) : (
                          locations?.map((location, index) => (
                            <div>
                              <div
                                className="d-flex flex-wrap w-100 p-2 align-items-start"
                                key={index}
                              >
                                <span className="text-sm text-white w-50 w-sm-100 text-start">
                                  <p className="text-blue mb-8">
                                    <h6>{location.name}</h6>
                                  </p>
                                </span>
                                <span className="text-sm text-main-two-600 w-50 w-sm-100 text-start d-flex gap-2">
                                  <a
                                    href="#"
                                    className="text-blue"
                                    onClick={() => handleEdit(location.id)}
                                  >
                                    Edit
                                  </a>
                                  &nbsp;| &nbsp;
                                  <a
                                    href="#"
                                    onClick={(event) =>
                                      handleDelete(location.id, event)
                                    }
                                    className="text-blue"
                                  >
                                    Delete
                                  </a>
                                </span>
                              </div>

                              <div>
                                <div className="d-flex flex-wrap w-100 p-2 align-items-start">
                                  <span className="text-sm text-white w-50 w-sm-100 text-start d-inline-block">
                                    <p className="text-black m-0">Address</p>
                                  </span>
                                  <span className="text-sm text-main-two-600 w-50 w-sm-100 text-start d-flex align-items-start">
                                    <p className="text-black m-0">
                                      {[
                                        location.delivery_address
                                          .address_line_1,
                                        location.delivery_address
                                          .address_line_2,
                                        location.delivery_address
                                          .address_line_3,
                                        location.delivery_address.postal_code,
                                        location.delivery_address.street,
                                        location.delivery_address.city,
                                      ]
                                        .filter(Boolean) // Removes empty or undefined values
                                        .join(", ")}
                                    </p>
                                  </span>
                                </div>
                                <div className="d-flex flex-wrap w-100 p-2 align-items-start">
                                  <span className="text-sm text-white w-50 w-sm-100 text-start d-inline-block">
                                    <p className="text-black m-0">
                                      Contact person
                                    </p>
                                  </span>
                                  <span className="text-sm text-main-two-600 w-50 w-sm-100 text-start d-flex align-items-start">
                                    <p className="text-black m-0">
                                      {location.recipient}
                                    </p>
                                  </span>
                                </div>
                                <div className="d-flex flex-wrap w-100 p-2 align-items-start">
                                  <span className="text-sm text-white w-50 w-sm-100 text-start d-inline-block">
                                    <p className="text-black m-0">
                                      Contact phone
                                    </p>
                                  </span>
                                  <span className="text-sm text-main-two-600 w-50 w-sm-100 text-start d-flex align-items-start">
                                    <p className="text-black m-0">
                                      {" "}
                                      {location.delivery_address.landline}
                                    </p>
                                  </span>
                                </div>
                                <div className="d-flex flex-wrap w-100 p-2 align-items-start">
                                  <span className="text-sm text-white w-50 w-sm-100 text-start d-inline-block">
                                    <p className="text-black m-0">
                                      Contact email
                                    </p>
                                  </span>
                                  <span className="text-sm text-main-two-600 w-50 w-sm-100 text-start d-flex align-items-start">
                                    <p className="text-black m-0">
                                      {location.delivery_address.email}
                                    </p>
                                  </span>
                                </div>
                              </div>
                              <hr></hr>
                            </div>
                          ))
                        )}
                      </div>

                      <a
                        href="/self-service/mycompany/actions"
                        className="d-flex align-items-center gap-2 text-decoration-none"
                      >
                        <span className="w-20 h-20 bg-main-50 text-xs d-flex justify-content-center align-items-center rounded-circle">
                          <i className="ph ph-plus"></i>
                        </span>
                        &nbsp;&nbsp;Add another delivery location
                      </a>
                      {isOpen && (
                        <CompanyActions onClose={() => setIsOpen(false)} />
                      )}
                    </div>
                    <br></br>
                    <div className="border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2 offer-card position-relative overflow-hidden p-16">
                      <div className="py-xl-4">
                        <h3 className="text-blue mb-8">Dispenser locations</h3>
                        <hr></hr>
                        {!locations_data.length ? (
                          <div className="d-flex flex-wrap w-100 p-2 align-items-start">
                            <span className="text-sm text-white w-50 w-sm-100 text-start">
                              <p className="text-black m-0">
                                Your company does not have free dispensers from
                                Dhofar Global.
                              </p>
                            </span>
                          </div>
                        ) : (
                          locations_data.map((location, index) => (
                            <div key={index}>
                              <div className="d-flex flex-wrap w-100 p-2 align-items-start">
                                <span className="text-sm text-white w-50 w-sm-100 text-start d-inline-block">
                                  <p className="text-black m-0">Address</p>
                                </span>
                                <span className="text-sm text-main-two-600 w-50 w-sm-100 text-start d-flex align-items-start">
                                  <p className="text-black m-0">
                                    {[
                                      location?.delivery_address?.name,
                                      location?.delivery_address
                                        ?.address_line_1,
                                      location?.delivery_address
                                        ?.address_line_2,
                                      location?.delivery_address
                                        ?.address_line_3,
                                      location?.delivery_address?.postal_code,
                                      location?.delivery_address?.street,
                                      location?.delivery_address?.city,
                                    ]
                                      .filter(Boolean) // Removes empty or undefined values
                                      .join(", ")}
                                  </p>
                                </span>
                              </div>
                              <div className="d-flex flex-wrap w-100 p-2 align-items-start">
                                <span className="text-sm text-white w-50 w-sm-100 text-start d-inline-block">
                                  <p className="text-black m-0">
                                    Contact phone
                                  </p>
                                </span>
                                <span className="text-sm text-main-two-600 w-50 w-sm-100 text-start d-flex align-items-start">
                                  <p className="text-black m-0">-</p>
                                </span>
                              </div>
                              <div className="d-flex flex-wrap w-100 p-2 align-items-start">
                                <span className="text-sm text-white w-50 w-sm-100 text-start d-inline-block">
                                  <p className="text-black m-0">
                                    Contact email
                                  </p>
                                </span>
                                <span className="text-sm text-main-two-600 w-50 w-sm-100 text-start d-flex align-items-start">
                                  <p className="text-black m-0">-</p>
                                </span>
                              </div>
                              <div className="d-flex flex-wrap w-100 p-2 align-items-start">
                                <span className="text-sm text-white w-50 w-sm-100 text-start d-inline-block">
                                  <p className="text-black m-0">Dispensers</p>
                                </span>
                                <span className="text-sm text-main-two-600 w-50 w-sm-100 text-start d-flex align-items-start">
                                  <p className="text-black m-0">-</p>
                                </span>
                              </div>
                            </div>
                          ))
                        )}

                        <hr></hr>
                        <div></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="tab-pane fade"
              id="pills-fruits"
              role="tabpanel"
              aria-labelledby="pills-fruits-tab"
              tabIndex={0}
            >
              <div className="container container-lg "></div>
              <div className="container container-lg ">
                <div className="row gy-4">
                  {/* grid for orders */}
                  <div className="col-sm-6 ">
                    <div className="border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2 offer-card position-relative overflow-hidden p-16">
                      <div className="py-xl-4">
                        <h3 className="text-blue ack mb-8">Local users</h3>
                        <hr></hr>
                        <div>
                          <div className="common-check common-radio mb-0">
                            <input
                              className="input-font form-check-input"
                              type="radio"
                              name="local_user_orders"
                              id="local_user_order_submits_true"
                              value={false}
                              checked={formData.local_user_orders === false}
                              onChange={handleOrderChange}
                            />
                            <label
                              className="lable-font form-check-label"
                              htmlFor="local_user_order_submits_true"
                            >
                              Local users send their orders to super-user
                            </label>
                          </div>
                          <hr></hr>
                          <div className="common-check common-radio mb-0">
                            <input
                              className="inout-font form-check-input"
                              type="radio"
                              name="local_user_orders"
                              id="local_user_order_submits_false"
                              value={true}
                              checked={formData.local_user_orders === true}
                              onChange={handleOrderChange}
                            />
                            <label
                              className="lable-font form-check-label"
                              htmlFor="local_user_order_submits_false"
                            >
                              Local users can place their orders themselves
                              without confirmation
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* grid for savings */}
                  <div className="col-sm-6 ">
                    <div className="border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2 offer-card position-relative overflow-hidden p-16">
                      <div className="py-xl-4">
                        <h3 className="text-blue mb-8">LPO</h3>
                        <hr></hr>
                        <div>
                          <div className="common-check common-radio mb-0">
                            <input
                              className="input-font form-check-input"
                              type="radio"
                              name="lpo_setting"
                              id="disabled"
                              value="disabled"
                              checked={formData.lpo_setting === "disabled"}
                              onChange={handleInputChange}
                            />
                            <label
                              className="lable-font form-check-label"
                              htmlFor="disabled"
                            >
                              Don’t need separate LPO document
                            </label>
                          </div>
                          <hr></hr>
                          <div className="common-check common-radio mb-0">
                            <input
                              className="input-font form-check-input"
                              type="radio"
                              name="lpo_setting"
                              id="system_lpo"
                              value="system_lpo"
                              checked={formData.lpo_setting === "system_lpo"}
                              onChange={handleInputChange}
                            />
                            <label
                              className="lable-font form-check-label"
                              htmlFor="system_lpo"
                            >
                              I want to generate formal LPO and send it to
                              confirmation
                            </label>
                          </div>
                          <hr></hr>
                          <div className="common-check common-radio mb-0">
                            <input
                              className="input-font form-check-input"
                              type="radio"
                              name="lpo_setting"
                              id="manual_lpo"
                              value="manual_lpo"
                              checked={formData.lpo_setting === "manual_lpo"}
                              onChange={handleInputChange}
                            />
                            <label
                              className="lable-font form-check-label"
                              htmlFor="manual_lpo"
                            >
                              I want to upload my own LPO
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </section>
  );
};

export default Company;
